import React from "react";
import ro from "/src/content/ro.json";

const PoliticaCookie = () => {
  const content = ro.legal.cookies;

  return (
    <div
      className="max-w-4xl mx-auto px-6 py-12"
      style={{ color: "var(--color-text)", backgroundColor: "var(--color-bg)" }}
    >
      <h1 className="text-3xl font-bold text-orange-500 mb-2">
        {content.title}
      </h1>
      <p className="text-sm opacity-80 mb-6">{content.updatedAt}</p>

      <p className="mb-6">{content.intro}</p>

      <h2 className="text-xl font-semibold mt-6">{content.section1.title}</h2>
      <p className="mt-2">{content.section1.p1}</p>
      <p className="mt-2">{content.section1.p2}</p>

      <h2 className="text-xl font-semibold mt-6">{content.section2.title}</h2>
      <div className="mt-2">
        <p>{content.section2.operator}</p>
        <p>{content.section2.cui}</p>
        <p>{content.section2.reg}</p>
      </div>

      <h2 className="text-xl font-semibold mt-6">{content.section3.title}</h2>

      <h3 className="text-lg font-semibold mt-4">{content.section3.a.title}</h3>
      <p className="mt-2">{content.section3.a.intro}</p>
      <ul className="list-disc pl-6 mt-2">
        {content.section3.a.items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
      <p className="mt-2">{content.section3.a.note}</p>

      <h3 className="text-lg font-semibold mt-4">{content.section3.b.title}</h3>
      <p className="mt-2">{content.section3.b.intro}</p>
      <ul className="list-disc pl-6 mt-2">
        {content.section3.b.items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
      <p className="mt-2">{content.section3.b.note}</p>

      <h3 className="text-lg font-semibold mt-4">{content.section3.c.title}</h3>
      <p className="mt-2">{content.section3.c.intro}</p>
      <ul className="list-disc pl-6 mt-2">
        {content.section3.c.items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
      <p className="mt-2">{content.section3.c.p1}</p>
      <p className="mt-2">{content.section3.c.p2}</p>

      <h2 className="text-xl font-semibold mt-6">{content.section4.title}</h2>
      <p className="mt-2">{content.section4.intro}</p>
      <ul className="list-disc pl-6 mt-2">
        {content.section4.items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
      <p className="mt-2">{content.section4.note}</p>

      <h2 className="text-xl font-semibold mt-6">{content.section5.title}</h2>
      <p className="mt-2">{content.section5.intro}</p>
      <ul className="list-disc pl-6 mt-2">
        {content.section5.items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>

      <h2 className="text-xl font-semibold mt-6">{content.section6.title}</h2>
      <p className="mt-2">{content.section6.p1}</p>
      <p className="mt-2">{content.section6.p2}</p>
      <ul className="list-disc pl-6 mt-2">
        {content.section6.items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>

      <h2 className="text-xl font-semibold mt-6">{content.section7.title}</h2>
      <p className="mt-2">{content.section7.intro}</p>
      <ul className="list-disc pl-6 mt-2">
        {content.section7.items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
      <p className="mt-2">{content.section7.note}</p>

      <h2 className="text-xl font-semibold mt-6">{content.section8.title}</h2>
      <p className="mt-2">{content.section8.intro}</p>
      <ul className="list-disc pl-6 mt-2">
        {content.section8.items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
      <p className="mt-2">{content.section8.note}</p>

      <h2 className="text-xl font-semibold mt-6">{content.section9.title}</h2>
      <p className="mt-2">{content.section9.text}</p>
    </div>
  );
};

export default PoliticaCookie;
